import * as React from 'react';
import {X} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import type {ReactNode} from 'react';
import type {MultiValueChipProps} from './types';
import type {SelectValue} from '../types';

function DefaultMultiValueChip<T, V extends SelectValue, L extends ReactNode>({
  option,
  readOnly,
  onRemove,
}: MultiValueChipProps<T, V, L>) {
  const {t} = useTranslation();
  const labelText =
    typeof option.label === 'string' ? option.label : String(option.value);

  return (
    <span className="inline-flex items-center gap-1 rounded-md border border-[var(--chekin-color-gray-3)] bg-[var(--chekin-color-surface-pressed)] py-0.5 pl-2 pr-1 text-[13px] font-medium text-[var(--chekin-color-brand-navy)] transition-colors">
      <span className="whitespace-nowrap leading-5">{option.label as ReactNode}</span>
      {!readOnly && (
        <button
          type="button"
          onClick={event => {
            event.stopPropagation();
            onRemove();
          }}
          onMouseDown={event => event.stopPropagation()}
          className="flex h-4 w-4 items-center justify-center rounded-sm border-0 bg-transparent p-0 text-[var(--chekin-color-gray-1)] outline-none transition-colors hover:bg-white/70 hover:text-[var(--chekin-color-brand-navy)] focus-visible:ring-2 focus-visible:ring-[var(--chekin-color-brand-blue)]/30"
          aria-label={t('remove_item', {label: labelText})}
        >
          <X size={12} strokeWidth={2.5} />
        </button>
      )}
    </span>
  );
}

export {DefaultMultiValueChip};
